import { Anchor, Button, Paragraph, Text, TextButton } from '@zillow/constellation-10';
import type { ElementType } from 'react';

import type { TextStyledComponentProps } from '../../model/TextStyledComponent';

const TextMap = {
  text: Text,
  paragraph: Paragraph,
} as const;

//  No use case exists yet for Button or TextButton
const CTAMap = {
  anchor: Anchor,
  button: Button,
  textButton: TextButton,
} as const;

type Props = {
  styledComponentContent: TextStyledComponentProps;
  csEventsHandler?: ({ text }: { text: string }) => void;
  csEventsIdMap?: Record<string, string>;
};

export const TextStyledComponent = ({ styledComponentContent, csEventsHandler, csEventsIdMap }: Props) => {
  if (!styledComponentContent.type) {
    styledComponentContent.type = 'text';
  }

  const DynamicTextComponent: ElementType = styledComponentContent.ctaType
    ? CTAMap[styledComponentContent.ctaType as keyof typeof CTAMap]
    : TextMap[styledComponentContent.type as keyof typeof TextMap];

  const anchorProps =
    styledComponentContent.ctaType === 'anchor'
      ? {
          href: styledComponentContent.url,
          target: '_blank',
          onClick: csEventsHandler ? () => csEventsHandler(styledComponentContent) : undefined,
          ['data-eventid']: csEventsIdMap?.[styledComponentContent.text],
        }
      : null;

  return (
    <DynamicTextComponent
      data-testid="TextStyledComponent"
      textStyle={styledComponentContent.styles.fontType}
      color={styledComponentContent.styles.fontColor}
      {...anchorProps}
    >
      {styledComponentContent.text}
    </DynamicTextComponent>
  );
};
